import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SERVICES } from "../data";

export const Services = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="services" className="section deep" data-testid="services-section">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
        <p className="eyebrow">Full service Kaua'i property care</p>
        <h2 className="h2">Twelve services.<br />One local call.</h2>
        <p className="sub">From guinea grass clearing to koi pond care, fence repair to rental turnovers — every service is delivered by Lucho or coordinated with trusted local connections, with clear communication the whole way.</p>
      </motion.div>

      <div className="svc-grid">
        <div className="svc-list" role="list">
          {SERVICES.map((s, i) => {
            const open = active === i;
            return (
              <div key={s.name} role="listitem" className={"svc-row" + (open ? " is-open" : "")}>
                <button
                  type="button"
                  className="svc-head"
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  aria-expanded={open}
                  data-testid={`service-row-${i}`}
                >
                  <span className="svc-num">{String(i + 1).padStart(2, "0")}</span>
                  <span className="svc-name">{s.name}</span>
                  <span className="svc-plus" aria-hidden="true">{open ? "\u2212" : "+"}</span>
                </button>
                <AnimatePresence initial={false}>
                  {open && (
                    <motion.div
                      className="svc-detail"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: [0.65, 0, 0.35, 1] }}
                    >
                      <div className="svc-detail-inner">
                        <img className="svc-mobile-img" src={s.img} alt={s.name + " on Kaua'i"} loading="lazy" />
                        <p>{s.blurb}</p>
                        <ul className="scope">
                          {s.scope.map((x) => <li key={x}>{x}</li>)}
                        </ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
        <div className="svc-frame" aria-hidden="true">
          <div className="svc-frame-clip">
            <AnimatePresence mode="popLayout">
              <motion.img
                key={SERVICES[active].img}
                src={SERVICES[active].img}
                alt=""
                initial={{ opacity: 0, scale: 1.06 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6, ease: [0.65, 0, 0.35, 1] }}
              />
            </AnimatePresence>
            <span className="svc-frame-tag">{String(active + 1).padStart(2, "0")} / {SERVICES[active].name}</span>
          </div>
        </div>
      </div>

      <div className="refs">
        <span className="ref">Also connected for:</span><span className="ref">Painting</span><span className="ref">Building &amp; repairs</span><span className="ref">Heavy tree removal</span><span className="ref">Solar consultation</span>
      </div>
    </section>
  );
};
